// The shape of a legal page's text. The pages are plain data so the copy can be
// read, tested and checked against the repo without rendering anything.
//
// Inline text knows two things only (`inline.tsx`): `**bold**`, and e-mail
// addresses and `https://` addresses, which become links.

export type LegalLang = "en" | "de";

export type LegalBlock =
  | { readonly kind: "p"; readonly text: string }
  | { readonly kind: "list"; readonly items: readonly string[] }
  /** Label/value rows: the imprint's details, the retention summary. */
  | { readonly kind: "rows"; readonly rows: readonly (readonly [string, string])[] };

export interface LegalSection {
  /** The anchor (`/privacy#figma`). Stable across languages. */
  readonly id: string;
  readonly heading: string;
  readonly blocks: readonly LegalBlock[];
}

export interface LegalDoc {
  readonly title: string;
  readonly intro: string;
  readonly sections: readonly LegalSection[];
}

export const p = (text: string): LegalBlock => ({ kind: "p", text });
export const list = (...items: string[]): LegalBlock => ({ kind: "list", items });
export const rows = (...pairs: (readonly [string, string])[]): LegalBlock => ({
  kind: "rows",
  rows: pairs,
});
